import { Injectable } from '@angular/core';
import { properties } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Event } from '../models/events-response';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private http: HttpClient) {}

  private allEvents: Event[];

  getEvents(): Promise<Event[]> {
    if (this.allEvents) {
      return new Promise((resolve) => {
        resolve(this.allEvents);
      })
    } else {
      return this.fetchEvents();
    }
  }

  private fetchEvents(): Promise<Event[]> {
    return new Promise((resolve, reject) => {
      this.http.get(`${properties.eventhubApi}/events`).subscribe(
        (response: Event[]) => {
          this.allEvents = response;
          resolve(response);
        },
        (error) => {
          reject(`Unable to get events.`);
        }
      );
    });
  }

  getEventDetails(eventSource: string, eventId: string): Promise<Event> {
    return new Promise((resolve, reject) => {
      this.http.get(`${properties.eventhubApi}/event/${eventSource}/${eventId}`).subscribe(
        (response: Event) => {
          resolve(response);
        },
        (error) => {
          reject(`Unable to get event details for event ${eventId}.`);
        }
      );
    });
  }
}
